<template>
  <Teleport to="body">
<div class="modal fade" :id="modalId" tabindex="-1" ref="modalEl">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Tratamentos</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <div class="modal-body">
          <div class="text-center py-5 text-muted" v-if="loading">Carregando...</div>
          <div class="text-muted" v-else-if="!treatments.length">Nenhum tratamento encontrado.</div>
          <div class="table-responsive" v-else>
            <table class="table table-row-bordered align-middle mb-0">
              <thead>
              <tr class="fw-bold text-muted fs-7">
                <th>#</th>
                <th>Período</th>
                <th>Status</th>
                <th>Procedimentos</th>
                <th class="text-end">Ação</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in treatments" :key="item.id_treatment">
                <td>{{ item.id_treatment }}</td>
                <td>
                  <span>{{ formatDate(item.opened_at) }}</span>
                  <span v-if="item.closed_at" class="text-muted"> — {{ formatDate(item.closed_at) }}</span>
                </td>
                <td>
                  <span class="badge" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
                </td>
                <td>{{ procedureCount(item) }}</td>
                <td class="text-end">
                  <button type="button"
                          class="btn btn-sm"
                          :class="item.id_treatment === activeId ? 'btn-light-primary' : 'btn-light'"
                          @click="select(item)">
                    {{ item.id_treatment === activeId ? 'Visualizando' : 'Visualizar' }}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
import http from '@/helpers/http';

export default {
  name: 'OdontogramTreatmentHistoryModal',
  props: {
    modalId: { type: String, required: true },
    treatmentsUrl: { type: String, required: true },
    activeId: { type: Number, default: null },
  },
  emits: ['select'],
  data() {
    return {
      loading: false,
      treatments: [],
    };
  },
  methods: {
    open() {
      this.load();
      window.bootstrap.Modal.getOrCreateInstance(this.$refs.modalEl).show();
    },

    async load() {
      this.loading = true;
      try {
        const response = await http.get(this.treatmentsUrl);
        this.treatments = response.data ?? [];
      } catch (_) {
        this.treatments = [];
      } finally {
        this.loading = false;
      }
    },

    select(treatment) {
      this.$emit('select', treatment);
      window.bootstrap.Modal.getOrCreateInstance(this.$refs.modalEl).hide();
    },

    formatDate(value) {
      if (!value) {
        return '—';
      }

      return new Date(value).toLocaleDateString('pt-BR');
    },

    statusLabel(status) {
      return {
        open: 'Em andamento',
        closed: 'Encerrado',
        canceled: 'Cancelado',
      }[status] ?? status;
    },

    statusClass(status) {
      if (status === 'open') {
        return 'badge-light-primary';
      }

      if (status === 'closed') {
        return 'badge-light-secondary';
      }

      return 'badge-light-danger';
    },

    procedureCount(treatment) {
      return (treatment.procedures ?? []).length;
    },
  },
};
</script>
